export const faq = {
  seo: {
    title: 'Häufig gestellte Fragen zu Bistroo | Bistroo',
    description: 'Antworten auf die häufigsten Fragen zu Bistroo: Preise, Onboarding, Hardware, Auszahlungen und mehr.',
  },
  hero: {
    heading: {
      1: 'Die',
      2: 'am häufigsten gestellten Fragen',
      3: 'auf einer übersichtlichen Seite',
    },
    description: {
      1: 'Hast du eine Frage? Gute Chance, dass du die Antwort bereits unten findest. Wir haben die am häufigsten gestellten Fragen für dich zusammengestellt, damit du schnell und einfach selbst weiterkommst.',
      2: 'Kommst du dennoch nicht weiter? Dann steht unser Kundenservice natürlich für dich bereit.',
    },
  },
  questions: {
    1: {
      question: 'Was ist Bistroo und wie funktioniert es?',
      answer:
        'Bistroo ist ein innovatives Softwareunternehmen, das sich auf die Digitalisierung der Gastronomie konzentriert. Das Unternehmen bietet benutzerfreundliche Tools an, mit denen Restaurants, Cafés und andere Gastronomiebetriebe ihre Online-Präsenz verbessern und selbstständig verwalten können.',
      bullet_title: 'Bistroo bietet unter anderem:',
      bullets: {
        1: 'Websites und Webshops für Gastronomiebetriebe, vollständig anpassbar nach deinen Wünschen.',
        2: 'QR-Module, mit denen Kunden einfach über ihr Mobiltelefon vor Ort bestellen und bezahlen können.',
        3: 'Ein Verwaltungssystem, in dem du alles selbst einstellen kannst: Menüs, Öffnungszeiten, Aktionen, Liefereinstellungen und mehr.',
      },
      how: 'Wie funktioniert es?',
      list: {
        1: 'Du erstellst ein Konto bei Bistroo und richtest deine digitale Umgebung ein. Du kannst deine Speisekarte hinzufügen, Einstellungen ändern, die Zahlungsmethode verknüpfen und selbst bestimmen, wie dein Online-Restaurant aussieht.',
        2: 'Sobald alles bereit ist, geht deine Website, dein Webshop oder dein QR-Modul live. Kunden können dich finden, Bestellungen aufgeben oder vor Ort per QR bestellen.',
        3: 'Du behältst die vollständige Kontrolle über deinen Shop. Alles ist selbst einstellbar, aber wenn du Hilfe benötigst, steht das Support-Team von Bistroo für dich bereit, um dich optimal zu unterstützen.',
      },
    },
    2: {
      question: 'Ist Bistroo kostenlos?',
      answer:
        'Ja, Bistroo bietet ein kostenloses Einstiegspaket an. Das bedeutet, dass du als Gastronom die Module kostenlos nutzen kannst, ohne monatliche Abonnementgebühren oder Startkosten.',
      how: 'Wie funktioniert das kostenlose Paket?',
      bullets: {
        1: 'Kostenloser Start: Du kannst sofort mit dem Einrichten deines Webshops und deiner Website beginnen, keine Startkosten! Nur beim QR-Modul berechnen wir die Selbstkosten der Aufkleber.',
        2: 'Keine Abonnementgebühren: Wir berechnen keine festen Abonnementgebühren, wir verlangen nur eine volumenbasierte Gebühr bei einer erfolgreichen Bestellung.',
        3: 'Selbst einzurichten: Du hast Zugang zu allen Grundfunktionen, um deine digitale Umgebung vollständig nach Wunsch einzurichten.',
        4: 'Support verfügbar: Auch als kostenloser Nutzer kannst du auf Unterstützung unseres Support-Teams zählen.',
        5: 'Einfach wechseln: Du kannst jeden Monat zu einem anderen Paket wechseln.',
      },
      why: 'Warum dieses Modell?',
      why_answer:
        'Bistroo möchte Gastronomen die Freiheit geben, ohne finanzielle Hürden mit der Digitalisierung zu beginnen. Erst wenn du tatsächlich Ergebnisse erzielst, zahlst du eine volumenbasierte Gebühr. Das macht es zu einer niedrigschwelligen und fairen Lösung für sowohl aufstrebende als auch etablierte Gastronomiebetriebe.',
    },
    3: {
      question: 'Kann ich Bistroo zuerst ausprobieren?',
      answer:
        'Ja, sicher! Alle Pakete von Bistroo können 30 Tage kostenlos ausprobiert werden. Das bedeutet, dass du unverbindlich alle Funktionalitäten des Pakets nutzen kannst, das zu deinem Gastronomiebetrieb passt, egal ob du eine Website, einen Webshop oder ein QR-Bestellmodul wählst.',
      what: 'Was beinhaltet die Testphase?',
      bullets: {
        1: '30 Tage kostenloser Zugang zu allen Funktionen des gewählten Pakets.',
        2: 'Vollständige Freiheit, deine digitale Umgebung einzurichten und zu testen.',
        3: 'Unterstützung durch das Support-Team während der gesamten Testphase.',
        4: 'Hardware zur Leihe (sofern zutreffend) während der Testphase.',
      },
    },
    4: {
      question: 'Wie geht ihr mit zusätzlichen Anfragen um?',
      answer: {
        1: 'Bei Bistroo nehmen wir zusätzliche Anfragen ernst. Unser Support-Team verarbeitet täglich alle eingehenden Anfragen, damit du schnell geholfen wirst und deine Online-Umgebung immer aktuell bleibt.',
        2: 'Außerdem halten wir wöchentlich eine Besprechung ab, in der wir alle eingegangenen Rückmeldungen und Anfragen besprechen. Während dieser Besprechung bewerten wir, welche Vorschläge in zukünftigen Feature-Updates berücksichtigt werden können.',
      },
    },
    5: {
      question: 'Wie funktionieren Auszahlungen bei Bistroo?',
      answer: {
        1: 'Bei Bistroo sind Auszahlungen einfach, flexibel und vollständig automatisiert.',
        2: 'Kurz gesagt: Du behältst die Kontrolle über deine Geldflüsse, und wir sorgen für einen reibungslosen und übersichtlichen Prozess. Ganz einfach.',
      },
      bullets: {
        1: 'Verknüpfe deinen Zahlungsanbieter mit unserem System.',
        2: 'Bestimme selbst den Auszahlungszeitpunkt: Du wählst, ob du täglich, wöchentlich oder monatlich ausgezahlt werden möchtest – genau so, wie es zu deinem Unternehmen passt.',
        3: 'Automatische Rechnungsstellung: Für jede Auszahlung wird automatisch eine Rechnung erstellt, damit deine Buchhaltung immer stimmt und aktuell ist.',
      },
    },
    6: {
      question: 'Warum sollte ich euch wählen? Was macht euch anders?',
      answer: {
        1: 'Mit Bistroo bist du wieder vollständig der Unternehmer. Unsere Lösung gibt dir als Verkäufer die Kontrolle über deinen Online-Shop. Du wirst wirklich zum Prozessinhaber, mit vollständiger Kontrolle über dein Online-Restaurant. Wir bieten alle Tools und Unterstützung, die du benötigst, um dein Restaurant online erfolgreich zu machen.',
        2: 'Im Manager, unserem benutzerfreundlichen Backoffice-Dashboard, verwaltest du einfach alles in Echtzeit: von Menüs, Preisen, Rabatten und Aktionen bis zu (Rück-)Zahlungen und Kundendaten. Alles übersichtlich und intuitiv, damit du dich auf das konzentrieren kannst, was wirklich zählt.',
        3: 'Bistroo bietet außerdem eine einzigartige Preisgestaltung: Du wählst das Kostenmodell, das zu deinem Unternehmen passt. Keine Überraschungen, kein Kleingedrucktes.',
        4: 'Bistroo gibt dir die Freiheit, online auf deine Weise zu unternehmen.',
      },
      bullets: {
        1: '30 Tage kostenlos ausprobieren',
        2: 'Monatlich kündbar',
        3: 'Keine versteckten Verträge, einfach klar und transparent',
      },
    },
    7: {
      question: 'Wie funktioniert die Administration?',
      answer: {
        1: 'Bei Bistroo ist die Administration so einfach wie möglich gestaltet. Für jede Auszahlung erhältst du automatisch eine klare Umsatzrechnung mit allen notwendigen Details. So kannst du diese direkt ohne Aufwand verbuchen.',
        2: 'Kurz gesagt: Deine Administration ist immer vollständig, übersichtlich und für deine Buchführung bereit, ohne zusätzliche manuelle Schritte.',
      },
    },
    8: {
      question: 'Wie lange dauert das Onboarding?',
      answer:
        'Bei Bistroo bist du schnell online: Innerhalb von 48 Stunden ist dein Online-Restaurant vollständig eingerichtet und betriebsbereit. So kannst du fast sofort mit dem Bestellen und Verkaufen beginnen!',
    },
    9: {
      question: 'Welche Zahlungsmethoden unterstützt ihr?',
      answer:
        'Bistroo arbeitet mit den führenden Zahlungsanbietern Stripe und Mollie zusammen. Über diese Partner unterstützen wir nahezu alle gängigen (und weniger gängigen) Zahlungsmethoden, sowohl in den Niederlanden als auch in Belgien. Denke an iDEAL, Bancontact, Apple Pay, Google Pay, Kreditkarte und viele weitere Zahlungsmethoden. Du hast selbst die vollständige Kontrolle über die Zahlungsmethoden, die du anbieten möchtest – schalte sie einfach über das Portal des Zahlungsanbieters an oder aus.',
    },
    10: {
      question: 'Wie erhalten wir die Bestellungen im Restaurant?',
      answer: {
        1: 'Bei Bistroo hast du mehrere flexible Optionen, um Bestellungen zu empfangen, abgestimmt auf das, was am besten zu deinem Restaurant passt. Bestellungen kommen standardmäßig direkt in deiner E-Mail-Inbox an. Benachrichtigungen erscheinen auch direkt in unserer Manager-App oder im Manager-Portal, und du kannst SMS-Benachrichtigungen aktivieren.',
        2: 'Möchtest du es ganz einfach machen? Wir liefern auch Hardware wie Bondrucker und Handhelds. Außerdem können wir in vielen Fällen deine bestehenden Drucker im Restaurant anschließen, damit du sofort loslegen kannst, ohne zusätzliche Geräte.',
        3: 'Darüber hinaus bieten wir oft auch Verbindungen mit Kassensystemen an, sodass Bestellungen nahtlos in deinen aktuellen Arbeitsablauf integriert werden. So sparst du Zeit und minimierst Fehler bei der Verarbeitung.',
        4: 'Kurz gesagt: Mit Bistroo wählst du selbst, wie du deine Bestellungen erhältst, vollständig auf dein Unternehmen zugeschnitten.',
      },
    },
    11: {
      question: 'Wie kann ich starten? Was ist dafür nötig?',
      answer:
        'Du kannst sofort starten, dafür ist überhaupt nichts nötig. Möchtest du loslegen? Erstelle einfach kostenlos ein Konto auf unserer Website, das geht sofort. Solltest du spezifische Hardware benötigen, kannst du diese optional bei uns kaufen, aber es ist absolut keine Voraussetzung.',
    },
    12: {
      question: 'Berechnet ihr Startkosten?',
      answer:
        'Bei uns zahlst du keine Startkosten. Ausschließlich für das QR-Modul berechnen wir die Selbstkosten der QR-Aufkleber.',
    },
    '15': {
      question: 'Was macht Bistroo einzigartig?',
      answer:
        'Mit der Software von Bistroo bist du wieder vollständig Unternehmer. Die Lösung von Bistroo gibt dir als Verkäufer die Kontrolle über deinen Online-Shop. Du wirst wirklich zum Prozessinhaber, mit vollständiger Kontrolle über dein Online-Restaurant über das Dashboard von Bistroo. Wir bieten alle Tools und Unterstützung, die du benötigst, um dein Restaurant online erfolgreich zu machen. Außerdem kannst du alles online über das Self-Onboarding von Bistroo regeln. Natürlich kommt das Team von Bistroo auch vor Ort vorbei, wenn dies nötig ist.',
    },
    '16': {
      question: 'Warum ist Bistroo eine bessere Alternative als Bestelldienste?',
      answer:
        'Bistroo unterscheidet sich durch den Fokus auf die Rentabilität des Unternehmers. Während traditionelle Bestelldienste volumenbasierte Gebühren von bis zu 30 % verlangen und Kundendaten für sich behalten, ist Bistroo ein Softwareanbieter mit einem festen und transparenten niedrigen Tarif. Der wichtigste Unterschied ist, dass der Unternehmer bei Bistroo Eigentümer der Kundendaten bleibt, was für Marketing und Kundenbindung wesentlich ist.',
    },
    '17': {
      question: 'Welche Produkte liefert Bistroo?',
      answer:
        'Bistroo liefert ein vollständiges E-Commerce-Gesamtpaket für die Gastronomie, alles verwaltbar über den Manager, mit folgenden Produkten: BistrooWebshop: Ein Webshop für Gastronomiebetriebe für Abhol- und Lieferbestellungen. BistrooPage: Website + Webshop für Gastronomiebetriebe über die Software von Bistroo. BistrooQR: QR-Modul, mit dem Kunden vor Ort bestellen und bezahlen können. BistrooManager: Ein Verwaltungssystem für Menü- und Einstellungsverwaltung. BistrooKiosk: Ein Bestellkiosk, über den Kunden vor Ort ihre Auswahl treffen können. BistrooPOS: Ein Kassensystem mit allen Funktionalitäten für Abholrestaurants.',
    },
    '18': {
      question: 'Kann ich die Software von Bistroo nutzen, wenn ich auch bei anderen Bestelldiensten vertreten bin?',
      answer:
        'Ja, die Software von Bistroo funktioniert hervorragend neben externen Bestelldiensten. Wir helfen dir mit Bistroo, einen eigenen direkten Bestellkanal über deinen eigenen Webshop aufzubauen, damit du weniger von einem Bestelldienst abhängig bist.',
    },
    '19': {
      question: 'Hat Bistroo einen Lieferdienst?',
      answer:
        'Nein, Bistroo bietet selbst keinen Lieferdienst an wie es Bestelldienste tun. Du kannst jedoch deine eigenen Fahrer einsetzen und diese vollständig über die Software von Bistroo verwalten.',
    },
    '20': {
      question: 'Kann ich mitmachen ohne eigene Fahrer?',
      answer:
        'Ja, du kannst mit der Software von Bistroo nur mit Abholung oder QR-Bestellungen vor Ort starten.',
    },
    '21': {
      question: 'Welche Ergebnisse erzielen Restaurants durchschnittlich mit der Software von Bistroo?',
      answer:
        'Aus unseren Fallstudien von Bistroo geht hervor, dass Restaurants, die aktiv auf ihren eigenen direkten Kanal setzen, ihre durchschnittliche Marge pro Bestellung um 15 % bis 25 % im Vergleich zu Bestelldiensten oder telefonischen Bestellungen steigen sehen. Außerdem sehen wir, dass der Bestellwert bei Bistroo QR-Bestellungen vor Ort oft 20 % höher liegt durch intelligente Upsell-Funktionen.',
    },
    '22': {
      question: 'Wie hilft Bistroo beim Aufbau eines Stammkundenkreises?',
      answer:
        'Bei Bistroo bist du Eigentümer der Daten. Du kannst Kunden, die längere Zeit nicht bestellt haben, einen persönlichen Aktionscode senden. Fallstudien zeigen, dass Restaurants mit der Software von Bistroo ihre Wiederholungsbesuche exponentiell steigern.',
    },
    '23': {
      question: 'Kann die Software von Bistroo hohe Volumen in Stoßzeiten verarbeiten?',
      answer:
        'Sicher. Wir haben verschiedene Fälle von geschäftigen Abholrestaurants und großen Terrassen, die in Stoßzeiten vollständig auf die stabile Software von Bistroo vertrauen. Die direkte Verbindung innerhalb des Systems von Bistroo sorgt dafür, dass die Fehlerquote in der Küche auf nahezu null reduziert wird. Die intelligenten Zeitfenster sorgen für eine gute Verteilung der Bestellungen oder Produkte in der Stoßzeit, was über andere Systeme oder das Telefon nicht regelbar ist.',
    },
    '24': {
      question: 'Wie erleben Unternehmer den Wechsel zur Software von Bistroo?',
      answer:
        'Unternehmer nennen oft die "Freiheit" von Bistroo im Vergleich zu Bestelldiensten als größten Pluspunkt. Außerdem sehen Restaurants einen enormen Effizienzgewinn im Vergleich zu telefonischen Bestellungen. Die Möglichkeit, das Menü direkt anzupassen oder eine Aktion über den Bistroo Manager live zu schalten, wird ebenfalls als sehr wertvoll empfunden.',
    },
    '26': {
      question:
        'Ist die Software von Bistroo geeignet für Franchiseketten oder Unternehmen mit mehreren Standorten?',
      answer:
        'Ja, der Bistroo Manager ist auf Skalierbarkeit ausgelegt. Von einem zentralen Konto aus können Unternehmer mehrere Filialen mit der Software von Bistroo verwalten. Unsere Split-Payment-Konstruktion macht den Zahlungsfluss auch sehr reibungslos ohne zusätzliche Administration.',
    },
    '27': {
      question:
        "Bietet Bistroo auch Lösungen für 'Dark Kitchens' oder Lieferrestaurants ohne Sitzplätze?",
      answer:
        'Absolut. Für Dark Kitchens bietet Bistroo einen optimierten Workflow, bei dem Bestellungen direkt auf dem Handheld eingehen, wodurch die Unabhängigkeit von externen Bestelldiensten durch die Software von Bistroo gewährleistet wird.',
    },
    '28': {
      question: 'Mit welchen Kassensystemen arbeitet die Software von Bistroo zusammen?',
      answer:
        'Die Software von Bistroo arbeitet mit Lightspeed, Winston Pos, Untill und Cashdesk zusammen. Außerdem liefert Bistroo ein eigenes Kassensystem, das vollständig mit unseren anderen Produkten verbunden ist.',
    },
    '29': {
      question: 'Kann ich meine Buchhaltung mit dem System von Bistroo verbinden?',
      answer:
        'Bistroo ermöglicht eine effiziente Administration durch Exporte, die mit den meisten Buchhaltungspaketen kompatibel sind. Dank der Zusammenarbeit mit Zahlungsanbieter Stripe werden Finanzströme übersichtlich berichtet, was die Verarbeitung in Paketen wie Exact Online, Twinfield oder Yuki erheblich beschleunigt.',
    },
    '30': {
      question: 'Erstellt ihr eine Website für mich mit der Software von Bistroo?',
      answer:
        'Ja, mit dem Produkt BistrooPage erstellen wir eine vollständige Website für dich, die auf Konversion optimiert ist.',
    },
    '31': {
      question: 'Ich habe bereits eine eigene Website, kann ich die Software von Bistroo trotzdem nutzen?',
      answer:
        'Ja, über den Bistroo Button kannst du deinen Bistroo Webshop einfach mit deiner bestehenden Seite verknüpfen.',
    },
    '32': {
      question: 'Ich habe bereits eine eigene Domain, kann ich diese mit der Software von Bistroo verbinden?',
      answer:
        'Ja, du kannst deine Domain mit einem neuen BistrooWebshop oder BistrooPage über einen Übertragungscode verbinden, den das Team von Bistroo für dich verarbeitet.',
    },
    '33': {
      question: 'Wie hilft die Software von Bistroo bei der Lösung von Personalmangel?',
      answer:
        'Durch den Einsatz des Bistroo QR-Moduls oder des BistrooKiosks können Gäste selbstständig bestellen. Dies verringert den Druck auf das Personal, wodurch es mit Hilfe der Software von Bistroo mehr Arbeit erledigen kann.',
    },
    '34': {
      question: 'Wie hilft Bistroo meinem Restaurant, bei Google höher zu ranken?',
      answer:
        'Bei dem Produkt BistrooPage optimieren wir die Website technisch (SEO). Da das Menü über Bistroo in HTML-Text auf der Seite steht, kann Google die Gerichte indexieren.',
    },
    '35': {
      question: 'Kann ich die Software von Bistroo kostenlos ausprobieren?',
      answer:
        'Ja, alle Pakete von Bistroo können 30 Tage kostenlos und unverbindlich ohne Startkosten ausprobiert werden!',
    },
    '36': {
      question: 'Was kostet die Software von Bistroo?',
      answer:
        'Bistroo berechnet einen festen Monatsbetrag bei den Abonnements oder ein kostenloses Modul, bei dem du nur eine Volume-Fee pro Bestellung zahlst. Zusätzliche Kosten wie Bistroo Hardware werden separat berechnet. Keine Startkosten! Schaue auf der Website nach den spezifischen Preisen für die Produkte.',
    },
    '37': {
      question: 'Kann ich monatlich kündigen bei Bistroo?',
      answer: 'Unsere Abonnements sind immer monatlich kündbar.',
    },
    '38': {
      question: 'Bekomme ich einen Rabatt, wenn ich ein Jahr im Voraus bei Bistroo zahle?',
      answer:
        'Ja, wenn du ein Jahr im Voraus zahlen möchtest, bekommst du bei Bistroo einen Rabatt auf das Abonnement.',
    },
    '39': {
      question: 'Was ist nötig, um bei Bistroo zu starten?',
      answer:
        'Du kannst sofort mit Bistroo starten, dafür ist überhaupt nichts nötig außer einem Konto auf der Website von Bistroo.',
    },
    '40': {
      question: 'Was brauche ich, um mit der Software von Bistroo zu starten?',
      answer:
        'Ein mobiles Gerät, Internet und deine Restaurantdaten reichen aus, um mit der Software von Bistroo zu beginnen.',
    },
    '41': {
      question: 'Wie melde ich mich bei Bistroo an?',
      answer:
        'Du kannst dich über die Website von Bistroo oder über WhatsApp unter 085-0250205 anmelden. Ein eigenes Konto erstellen ist möglich auf merchant.bistroo.nl/register.',
    },
    '42': {
      question: 'Bekomme ich Hilfe beim Einrichten meines Bistroo Kontos?',
      answer: 'Ja, Bistroo bietet persönliches Onboarding an, sowohl vor Ort als auch remote.',
    },
    '43': {
      question: 'Bekomme ich Hilfe beim Einrichten meines Online-Menüs in der Software von Bistroo?',
      answer:
        'Sicher! Das Support-Team von Bistroo hilft beim Einrichten deines Menüs und gibt Erklärungen zu Änderungen.',
    },
    '44': {
      question:
        'Was, wenn ich keine Ahnung von Technik habe, kann ich dann die Software von Bistroo nutzen?',
      answer:
        'Sicher! Die Software von Bistroo ist sehr benutzerfreundlich gestaltet und wir helfen dir Schritt für Schritt.',
    },
    '45': {
      question: 'Welche Hardware liefert Bistroo?',
      answer:
        'Bistroo liefert ein Handheld-Gerät von Sunmi. Wir können auf Anfrage Laptops liefern, wir liefern USB/WLAN/Internet-Bondrucker der Marke Epson und einen Cloud-Drucker der Marke Sunmi. Wir liefern auch die Hardware für unser Kassensystem, bestehend aus: einem PIN-Terminal, einem Sunmi-Display, einem Sunmi-Cloud-Drucker und einer Kassenschublade. Andere Hardware ist auf Anfrage möglich, unsere Software läuft auf allem. Für unsere Bestellkioske gibt es verschiedene Modelle zu kaufen, diese reichen von einem Einstiegsmodell bis zu vollständig ausgebauten doppelwandigen Kiosken.',
    },
    '46': {
      question: 'Wie funktioniert das Handheld von Bistroo?',
      answer:
        'Das Sunmi Handheld von Bistroo ist einfach für Auftragsmanagement und Belegdruck mit der Software von Bistroo zu bedienen.',
    },
    '47': {
      question: 'Funktioniert die Software von Bistroo auf meiner bestehenden Hardware?',
      answer: 'Ja, die Software von Bistroo läuft auf jedem modernen Gerät mit einem Browser.',
    },
    '48': {
      question: 'Was muss ich tun, wenn die Software von Bistroo keine Internetverbindung hat?',
      answer:
        'Nutze einen Hotspot oder kontaktiere den Kundenservice von Bistroo, um eine SIM-Karte zu aktivieren.',
    },
    '49': {
      question: 'Wie wechsle ich das WLAN auf dem Handheld von Bistroo?',
      answer:
        'Über die Einstellungen des Bistroo-Geräts kannst du einfach das Netzwerk wechseln für eine stabile Verbindung.',
    },
    '50': {
      question: 'Ist eine SIM-Karte in den Geräten von Bistroo?',
      answer:
        'Ja, in den Geräten von Bistroo ist eine SIM-Karte, die auf Anfrage aktiviert werden kann.',
    },
    '51': {
      question: 'Der Drucker des Handhelds funktioniert nicht, was muss ich tun?',
      answer:
        'Überprüfe die Bonrolle und die Verbindung oder kontaktiere den Support von Bistroo.',
    },
    '52': {
      question: 'Wie wechsle ich die Bonrolle in den Geräten von Bistroo?',
      answer:
        'Lege die Rolle mit der Papierseite nach vorne in das Bistroo-Gerät und teste einen Druck.',
    },
    '53': {
      question: 'Welche Größe Bonrolle muss ich für das Bistroo Handheld verwenden?',
      answer: 'In das Sunmi Handheld von Bistroo passen 57x40x12 thermoweiße Bonrollen.',
    },
    '54': {
      question: 'Werden mir Bonrollen von Bistroo geliefert?',
      answer:
        'Du bekommst standardmäßig eine Rolle bei der Lieferung von Bistroo. Zusätzliche Rollen können bei Bistroo über 123inkt bestellt werden. Für das Handheld ist dies folgende URL: https://www.123inkt.nl/123inkt-kassarol-57x40x12-thermo-wit-5-stuks-40349EC-K-6023C-i52200-t4160297.html',
    },
    '55': {
      question: 'Ersetzt Bistroo einen kaputten Drucker?',
      answer:
        'Ja, sofern sorgfältig mit den Geräten von Bistroo umgegangen wurde, ersetzen wir diese unter normalen Umständen.',
    },
    '56': {
      question: 'Kann ich die Sprache auf dem Handheld anpassen?',
      answer:
        'Ja, über die Einstellungen des Geräts. Für die Software von Bistroo wird jedoch Niederländisch oder Englisch empfohlen.',
    },
    '57': {
      question: 'Wo kann ich die Bonrollen für das Handheld von Bistroo kaufen?',
      answer:
        'Das ist über 123inkt möglich, über diesen Link: https://www.123inkt.nl/123inkt-kassarol-57x40x12-thermo-wit-5-stuks-40349EC-K-6023C-i52200-t4160297.html',
    },
    '58': {
      question: 'Welche Bestellkioske liefert Bistroo?',
      answer:
        'Wir bieten ein Einstiegsmodell von Sunmi an, können aber auch maßgeschneiderte Modelle über unsere Partner liefern. Informiere dich über die Möglichkeiten.',
    },
    '59': {
      question: 'Ich habe bereits Hardware, kann Bistroo diese nutzen?',
      answer:
        'Im Allgemeinen ja, aber wir benötigen ein deutliches Foto oder eine Modellnummer, um sicherzustellen, dass unsere Software gut auf der bestehenden Hardware laufen kann. Grundsätzlich gilt bei uns, dass wir auf allem laufen können.',
    },
    '60': {
      question: 'Ich möchte meinen Shop auf Bistroo schließen, wie mache ich das?',
      answer:
        'Setze den Online-Shop auf geschlossen im Bistroo Manager oder auf dem Handheld über den Schieberegler. Um remote zu schließen, gehe zu merchant.bistroo.nl.',
    },
    '61': {
      question: 'Wie öffne ich meinen Shop auf Bistroo an einem zusätzlichen Tag?',
      answer:
        "Öffne deinen Shop über den Schieberegler im Bistroo Manager oder stelle abweichende Öffnungszeiten unter 'Öffnungszeiten & Bedienung' ein, wenn du von deinen regulären Öffnungszeiten abweichst.",
    },
    '62': {
      question: 'Muss ich meinen Shop auf Bistroo nach der Schließung manuell wieder öffnen?',
      answer:
        'Nein. Sobald das eingestellte Datum abgelaufen ist, schaltet der Bistroo Manager automatisch wieder auf deinen regulären Wochenplan um.',
    },
    '63': {
      question: 'Kann ich eine vollständige Urlaubsperiode in der Software von Bistroo einplanen?',
      answer:
        'Ja. Du kannst mehrere Regeln bei den abweichenden Öffnungszeiten hinzufügen. Für jeden Urlaubstag fügst du einfach eine neue Regel im Bistroo Manager hinzu.',
    },
    '64': {
      question: 'Wie passe ich Lieferzeiten in der Software von Bistroo an?',
      answer:
        "Über den Bistroo Manager > Filialeinstellungen > 'Öffnungszeiten & Bedienung' > Öffnungszeiten oder abweichende Zeiten pro Vertriebskanal (Abholung, Lieferung, vor Ort).",
    },
    '65': {
      question: 'Wie passe ich meine Preise bei Bistroo an?',
      answer:
        'Gehe zu Produkte Lagerbestand im Bistroo Manager und klicke auf das Produkt, um den Preis anzupassen. Du kannst nach einem Produkt suchen, indem du im Suchfeld tippst.',
    },
    '66': {
      question: 'Wie aktualisiere ich mein Menü in der Software von Bistroo?',
      answer:
        'Passe Produkte oder Kategorien im Bistroo Manager an. Du kannst auch ein neues Menü erstellen und mit der Software von Bistroo verknüpfen.',
    },
    '67': {
      question: 'Wie verberge ich Produkte vorübergehend in der Software von Bistroo?',
      answer:
        'Schalte das Produkt vorübergehend im Bistroo Manager über den Schieberegler beim Produkt aus. Oder klicke auf Menü im Handheld von Bistroo und verwende dort die Schieberegler pro Produkt.',
    },
    '68': {
      question: 'Wie stelle ich Liefergebiete in der Software von Bistroo ein?',
      answer:
        "Gehe zu 'Öffnungszeiten & Bedienung' > Liefern im Bistroo Manager und füge dort Gebiete hinzu oder passe diese an.",
    },
    '69': {
      question: 'Wie ändere ich Lieferkosten in der Software von Bistroo?',
      answer:
        "Über 'Öffnungszeiten & Bedienung' > Liefern im Bistroo Manager passt du die Lieferkosten pro Gebiet an.",
    },
    '70': {
      question: 'Ich möchte kostenlos liefern über die Software von Bistroo, wie stelle ich das ein?',
      answer:
        'Setze die Lieferkosten auf 0 für das gewünschte Postleitzahlgebiet in den Einstellungen des Bistroo Managers.',
    },
    '71': {
      question: 'Kann ich eine Mittags- und Abendkarte gleichzeitig über die Software von Bistroo anbieten?',
      answer:
        'Ja, du kannst mehrere Menüs erstellen und zeitgebunden über die Software von Bistroo aktivieren.',
    },
    '72': {
      question: 'Kann ich ein Menü nur während einer bestimmten Zeit anbieten?',
      answer:
        'Ja, stelle über den Bistroo Manager ein, wann das Menü verfügbar ist (zum Beispiel nur Mittag oder Abend).',
    },
    '73': {
      question: 'Kann ich Produkte während einer bestimmten Zeit anbieten?',
      answer: 'Ja, über den Bistroo Manager kannst du Zeitfenster pro Kategorie einstellen.',
    },
    '74': {
      question: "Warum erscheint 'kein Getränk' auf dem Beleg von Bistroo?",
      answer:
        "Dies geschieht, wenn ein Produkt ein Auswahlmenü (Dropdown) hat, in dem 'kein Getränk' als Standardwert im Bistroo Manager eingestellt ist.",
    },
    '75': {
      question: "Ist es nötig, dass zum Beispiel 'kein Getränk' auf dem Beleg von Bistroo steht?",
      answer:
        'Nein. In den meisten Fällen ist dies überflüssig. Du kannst im Bistroo Manager einstellen, dass der erste Wert optional ist, sodass dieser nicht gedruckt wird.',
    },
    '76': {
      question: 'Wann erhalte ich meine Auszahlung von Bistroo?',
      answer:
        'Auszahlungen von Bistroo sind an den Zeitplan des Zahlungsanbieters Stripe gebunden. Der Umsatz für Online-Bestellungen wird standardmäßig von Donnerstag bis Mittwoch berechnet und am Montag ausgezahlt. Für PIN-Zahlungen ist dieser Zyklus anders.',
    },
    '77': {
      question: 'Die Auszahlung von Bistroo stimmt nicht, wie kann das sein?',
      answer:
        'Überprüfe die Umsatzrechnungen im Bistroo Manager. Hier ist der Einbehalt von Bistroo klar vermerkt.',
    },
    '78': {
      question: 'Wie überprüfe ich meine Auszahlungen in der Software von Bistroo?',
      answer:
        'Melde dich im Bistroo Manager über merchant.bistroo.nl > Rechnungen an. Hier siehst du pro Transaktion genau, was von Bistroo ausgezahlt wurde.',
    },
    '79': {
      question: 'Ich habe zu wenig Geld von Bistroo ausgezahlt bekommen, wie kann das sein?',
      answer:
        'Melde dich über den Bistroo Manager über merchant.bistroo.nl an und schaue unter dem Abschnitt Rechnungen und öffne die neueste Rechnung. Du siehst hier, welche Transaktionen in der Auszahlung enthalten waren. Bedenke, dass der standardmäßige wöchentliche Zyklus von Stripe für Online-Zahlungen von Donnerstag bis Mittwoch läuft, dieser wird dann am Montag ausgezahlt. Schaue auch, ob du in dem Zeitraum Rückerstattungen vorgenommen hast, dies ist ebenfalls deutlich auf der Umsatzrechnung vermerkt.',
    },
    '80': {
      question: 'Welche anderen Kosten werden von Bistroo einbehalten?',
      answer:
        'Transaktionskosten von Stripe, mögliche PIN-Kosten der Bank und gegebenenfalls Hardware-Ratenzahlungen oder Korrekturen werden von der Auszahlung von Bistroo einbehalten.',
    },
    '81': {
      question: 'Wie erhalte ich meine Rechnungen von Bistroo?',
      answer:
        'Rechnungen findest du im Bistroo Manager unter dem Abschnitt Fakturierung. Du bekommst diese auch wöchentlich von Bistroo an deine E-Mail-Adresse zugesandt.',
    },
    '82': {
      question: 'Wie lade ich meine Rechnungen von Bistroo herunter?',
      answer:
        'Gehe zu Rechnungen im Bistroo Manager, wähle den Zeitraum und lade als PDF- und Excel-Datei herunter.',
    },
    '83': {
      question: 'Wie erfahre ich meinen Tagesumsatz bei Bistroo?',
      answer:
        'Du findest deinen Tagesumsatz im Bistroo Manager auf dem Dashboard oder über Berichte auf dem Handheld von Bistroo.',
    },
    '84': {
      question: 'Wie drucke ich meinen Tagesumsatz über Bistroo?',
      answer:
        'Über den Berichtsbereich im Bistroo Manager kannst du Tagesberichte exportieren und drucken. Klicke dafür im Handheld von Bistroo auf das Symbol oben links auf dem Bildschirm.',
    },
    '85': {
      question: 'Was muss ich tun, wenn ich einen Fehler in einer Bestellung des Kunden gemacht habe?',
      answer:
        'Als Restaurantinhaber kannst du die Bestellung öffnen und eine (teilweise) Rückerstattung über das Handheld von Bistroo oder den Bistroo Manager durchführen.',
    },
    '86': {
      question: 'Wie storniere ich eine Bestellung in der Software von Bistroo?',
      answer:
        'Öffne die Bestellung im Manager von Bistroo und wähle Rückerstatten. Damit ist die Bestellung storniert.',
    },
    '87': {
      question: 'Wie löse ich eine Beschwerde mit der Software von Bistroo?',
      answer:
        'Löse eine Beschwerde direkt mit dem Verbraucher und gib gegebenenfalls einen Rabatt oder eine Rückerstattung über die Software von Bistroo.',
    },
    '88': {
      question: 'Löst ihr Beschwerden bei Bistroo?',
      answer:
        'Bistroo begleitet bei Beschwerden, aber der Restaurantinhaber bleibt verantwortlich für den Service, die Qualität des Essens und die Lieferung.',
    },
    '90': {
      question: 'Was, wenn ein Kunde bei einer Bistroo-Bestellung nicht öffnet?',
      answer:
        'Versuche zunächst telefonisch Kontakt aufzunehmen. Die Bestellung über Bistroo ist immer im Voraus bezahlt, also hast du kein direktes finanzielles Risiko.',
    },
    '91': {
      question: 'Ich möchte einen Aktionstag einrichten, bietet die Software von Bistroo diese Möglichkeit?',
      answer:
        'Nutze das Rabattmodul im Bistroo Manager, um eine Rabattaktion an bestimmten Tagen oder für einen bestimmten Zeitraum einzuplanen.',
    },
    '92': {
      question: 'Hilft Bistroo mir beim Werben?',
      answer:
        'Ja, Bistroo bietet 1.000 kostenlose Flyer bei einer ersten Aktion an. Außerdem kannst du White-Label-Flyer über Bistroo drucken lassen.',
    },
    '94': {
      question: 'Wie schnell passt ihr mein Menü an, wenn ich eine Änderung an Bistroo durchgebe?',
      answer:
        'Bistroo ist bestrebt, Änderungen innerhalb von 24–48 Stunden durchzuführen. Bei Dringlichkeit hilft Bistroo schneller.',
    },
    '95': {
      question: 'Wie erreiche ich den Kundenservice von Bistroo?',
      answer:
        "Das Team von Bistroo ist telefonisch oder über WhatsApp unter 085-0250205 erreichbar. Unsere E-Mail-Adresse ist klantenservice{'@'}bistroo.nl.",
    },
    '96': {
      question:
        'Wie kann ich testen, ob meine Änderungen in der Software von Bistroo erfolgreich waren?',
      answer:
        'Kontaktiere den Kundenservice von Bistroo, um die Online-Umgebung vorübergehend in den Testmodus zu schalten.',
    },
  },
}
